import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const activityApi = createApi({
  reducerPath: "activityApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}users/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["ActivityLogs", "Notifications"],
  endpoints: (builder) => ({
    getActivityLogs: builder.query({
      query: ({ page = 1, limit = 20, module = "", action = "" } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (module) params.append("module", module);
        if (action) params.append("action", action);
        return `activity-logs?${params.toString()}`;
      },
      providesTags: ["ActivityLogs"],
    }),
    getNotifications: builder.query({
      query: ({ page = 1, limit = 10, unread = "", excludeChat = false } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (unread) params.append("unread", unread);
        if (excludeChat) params.append("excludeChat", "true");
        return `notifications?${params.toString()}`;
      },
      providesTags: ["Notifications"],
    }),
    markNotificationRead: builder.mutation({
      query: (id) => ({
        url: `notifications/${id}/read`,
        method: "PATCH",
      }),
      invalidatesTags: ["Notifications"],
    }),
    markAllNotificationsRead: builder.mutation({
      query: () => ({
        url: "notifications/read-all",
        method: "PATCH",
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useGetActivityLogsQuery,
  useGetNotificationsQuery,
  useMarkNotificationReadMutation,
  useMarkAllNotificationsReadMutation,
} = activityApi;
